export const needItSooner = {
  dialogTitle: 'Submit Request',
  information:
    "We'll get back to you to confirm your order or answer any questions you may have, usually within 1-2 hours.",
  altImg: 'Rocket',
  deadline: 'Deadline (urgency fee may apply)',
  email: 'Email address',
  phone: 'Phone',
  notes: 'Notes or questions',
  upload: 'If you have your files ready, drag and drop here or ',
  browse: 'browse',
};
